"use client";

import { useScrollReveal } from "./useScrollReveal";
import { useI18n } from "@/lib/i18n/I18nProvider";

const METRICS_RU = [
  { value: "40+", unit: "отелей", label: "уже используют Keiront" },
  { value: "150+", unit: "объектов", label: "в сетях наших клиентов" },
  { value: "2–4", unit: "недели", label: "типовое внедрение при подготовленных мастер-данных" },
  { value: "30+", unit: "интеграций", label: "с системами отеля (Opera, 1С, Logus…)" },
];

const METRICS_EN = [
  { value: "40+", unit: "hotels", label: "already run on Keiront" },
  { value: "150+", unit: "properties", label: "across our clients' chains" },
  { value: "2–4", unit: "weeks", label: "typical onboarding with prepared master data" },
  { value: "30+", unit: "integrations", label: "with hotel systems (Opera, 1C, Logus…)" },
];

export function MetricsSection() {
  const { ref, style } = useScrollReveal();
  const { t, locale } = useI18n();
  const METRICS = locale === "en" ? METRICS_EN : METRICS_RU;

  return (
    <section className="py-16 bg-keiro-obsidian">
      <div
        ref={ref}
        className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${style}`}
      >
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-12">
          {METRICS.map((metric, index) => (
            <div key={index} className="text-center">
              <div className="flex items-baseline justify-center gap-1">
                <span className="font-mono text-4xl sm:text-5xl font-bold text-white tabular-nums">
                  {metric.value}
                </span>
                <span className="text-lg font-semibold text-keiro-green">
                  {metric.unit}
                </span>
              </div>
              <p className="mt-2 text-sm text-slate-400 leading-snug">
                {metric.label}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <a
            href="#demo"
            className="inline-flex items-center gap-2 bg-keiro-green hover:bg-keiro-green-dark text-white px-6 py-3 text-base font-semibold rounded-lg transition-colors"
          >
            {t("landing.cta.calculateSavings")}
          </a>
        </div>
      </div>
    </section>
  );
}
